import '../../node_modules/slim-js/dist/index';
import '../../node_modules/slim-js/dist/directives/all';
import './load-more';